<template>
  <div class="flex-col space-y-20 page">
    <div class="flex-col section_3">
      <div class="flex-col items-start text-wrapper"><span class="text_2">我的课程</span></div>
    </div>
    
    <div class="flex-col space-y-14 group_7" v-loading="loading" element-loading-text="数据正在加载中">
      <div v-if="courseList.length > 0">
        <div class="flex-col section_5" v-for="(item, index) in courseList">
          <div class="flex-row justify-between items-center">
            <span class="text_19" style="width: 60px;">{{index + 1}}</span>
            <span class="text_19" style="flex: 1;">{{item}}</span>
            <div class="flex-col items-center">
              <el-button type="primary" size="small" @click="openCourse(item)">学习课程</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex-col space-y-22 group_7">
          <el-empty description="暂无课程数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        loading: false,
        courseList: [],
      };
    },
    created() {
      let that = this;
      that.getUserCourses();
    },
    methods: {
      // 获取用户的课程列表
      getUserCourses() {
        let that = this;
        that.loading = true;
        
        that.$request.getUserCourses().then((res) => {
          if (res.code == 200 && res.datas.course_titles) {
            // 将course_titles按逗号分割成数组
            let courses = res.datas.course_titles.split(',');
            that.courseList = courses;
          }
          that.loading = false;
        }).catch(() => {
          that.loading = false;
        });
      },
      
      // 打开课程学习页面
      openCourse(courseName) {
        // 在新窗口打开学习网站
        window.open('https://www.guobiaorc.com/', '_blank');
      }
    },
  };
</script>

<style scoped lang="css">
  .space-y-20>*:not(:first-child) {
    margin-top: 1.25rem;
  }

  .page {
    background-color: #f5f6fa;
    width: calc(100% - 220px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    padding: 1.25rem 1.25rem 1.88rem;
  }

  .section_3 {
    padding: 0.63rem 1.25rem 0.63rem 3.13rem;
    background-color: #ffffff;
  }

  .text-wrapper {
    padding: 0.22rem 0 1.28rem;
    width: 6.75rem;
    border-bottom: solid 0.16rem #0074ff;
  }

  .text_2 {
    color: #0074ff;
    font-size: 1.13rem;
    font-family: Source Sans Pro;
    font-weight: 900;
    line-height: 1.06rem;
  }

  .space-y-14>*:not(:first-child) {
    margin-top: 0.88rem;
  }

  .group_7 {
    padding: 1.25rem 0.44rem 0;
  }

  .section_5 {
    margin-bottom: 1rem;
    background-color: #ffffff;
    border: solid 0.063rem #dcdfe6;
    border-radius: 0.31rem;
    padding: 1rem;
  }

  .text_19 {
    color: #3d3d3d;
    font-size: 1rem;
    font-family: Source Sans Pro;
    line-height: 1.5rem;
  }
</style>